import { GetPortfolioFromCexParams } from "../trade.types";

export const getPortfolioFromCex = async (params: GetPortfolioFromCexParams) => {
  const { vaultId, accountNames, provider } = params;
  if (!provider) return;

  const portfolio = await provider.request({
    method: "balances",
    params: {
      vaultId,
      accountNames,
    },
  });
  return portfolio as [];
};
